/**
 * 全局配置文件
 */
export default {
    // apiURL:"http://game.wangxiansheng.vip",   // 接口URL
    // apiURL:"http://sd17.com",
    apiURL:"http://cs888888.cn",
}
